/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonGroup } from "@blueprintjs/core"
import { WINDOW_ICON, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { ILandingStore, useLandingStore } from "../data/store"
import { useEffect } from "react"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"

/* Protopia Ecosystem component */
export interface ILandingDimentionFormProps {
   
}
const LandingDimentionWidget = (props: ILandingDimentionFormProps): JSX.Element => {
    const currentDimentionEdit = useLandingStore((state: ILandingStore) => state.currentDimentionEdit)
    const sizes = useScreenSize()
    useEffect(() => {
        useLandingStore.setState({ currentDimentionEdit: WINDOW_WIDTH[ sizes.dimention ] })
    }, [])

    const setDimention = (sz: string ) => {
        useLandingStore.setState({ currentDimentionEdit: sz })
    }
    return <div className='w-100 flex-center '>
        <ButtonGroup vertical={false}>
        {
            Object.keys(WINDOW_WIDTH)
            .filter((sz: string) => {
                return !!WINDOW_ICON[ sz  ]
            })
            .map((sz: string) => {
                const icon = WINDOW_ICON[ sz  ]
                return <Button key={ sz } className={ `${ currentDimentionEdit !== sz ? "opacity_5" : "" } p-3` } variant="minimal" onClick={() => setDimention(sz)}>
                    <i className={ `${ icon } fa-1x` } />
                </Button>
            })
        }
        </ButtonGroup>
    </div>
}
export default LandingDimentionWidget